import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import MemberDisciplinaryStatusForm from '../../../components/forms/MemberDisciplinaryStatusForm';
import { useCreateMemberDisciplinaryStatus } from '../../../hooks/useMemberDisciplinaryStatusApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { MemberDisciplinaryStatusDTO } from '../../../services/apiClient';

const MemberDisciplinaryStatusCreate: React.FC = () => {
  const createMutation = useCreateMemberDisciplinaryStatus();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Member Disciplinary Statuses', href: '/admin/memberdisciplinarystatuses' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: MemberDisciplinaryStatusDTO) => {
    try {
      await createMutation.mutateAsync(data);
      navigate('/admin/memberdisciplinarystatuses');
    } catch (error) {
      console.error('Error creating MemberDisciplinaryStatus:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/memberdisciplinarystatuses"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.MemberDisciplinaryStatus.Edit'
    >
        <MemberDisciplinaryStatusForm
          initialValues={{} as MemberDisciplinaryStatusDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/memberdisciplinarystatuses')}
        />
    </AdminLayout>
  );
};

export default MemberDisciplinaryStatusCreate;